import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {feedback_createFeedback_Api, feedback_deleteFeedback_Api, feedback_updateFeedback_Api} from "../../../../apis";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import CRUD from "../../../Shared/enums/CRUD";
import {Modal} from "antd";
import {DelayRender} from "../../../Discovery/DelayRender";
import {CreateFeedbackForm} from "../components/FeedbackForm";
import createInfoDialog from "../../factory/createInfoDialog";
import LoadingBlock from "../../../LoadingBlock";


export const useFeedback = ({
                              notifyListeners = {
                                onCreated: undefined,
                                onUpdated: undefined,
                                onDeleted: undefined,
                              },
                            }) => {
  const t = useTranslate()
  const [action, setAction] = useState({type: undefined, value: undefined})

  const handleAction = (action, params) => {
    switch (action) {
      case CRUD.CREATE:
        setAction({type: action, value: params})
        break
      default:
        break
    }
  }
  const handleReport = (params) => {
    handleAction(CRUD.CREATE, params)
  }
  // handleReport({ref_type: 'church', ref_id: '...', feedback_category_id: 'church-information'})

  const onCancel = () => {
    setAction({})
  }

  const onSuccess = () => {
    onCancel()
  }

  const {
    onCreated = undefined,
    onUpdated = NullAsDefault,
    onDeleted = NullAsDefault,
  } = notifyListeners ?? {}

  const onError = notifyOnError(t)

  const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
    onError,
    query: bindQueryParam({}),
    apiInfo: feedback_createFeedback_Api,
    onSuccess: (result, data) => {
      if (onCreated) {
        onCreated(result, data)
      } else {
        // successNotify(NotificationActionTypes.CREATE, t)
        createInfoDialog({
          title: t('send feed back successful'),
          message: t('send feed back successful message'),
          className: 'custom-modal',
          okText: t('got it'),
          okButtonProps: {
            type: 'default',
            size: 'small',
            className: 'no-shadow bg-transparent hover:bg-transparent no-border font-bold text-xs text-primary-400 italic',
          },
          onOk: () => {
            onCancel()
          }
        })
      }
    },
  })

  const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
    onError,
    apiInfo: feedback_updateFeedback_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.UPDATE, t)
      onUpdated(result, data)
    },
  })

  const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
    onError,
    apiInfo: feedback_deleteFeedback_Api,
    onSuccess: (result, data) => {
      successNotify(NotificationActionTypes.DELETE, t)
      onDeleted(result, data)
    },
  })

  const reportModal = useMemo(() => {
    let Content = NullAsDefault
    let Wrapper = ({children}) => children({initialValues: {}})
    let params = {initValues: {...action.value}}
    let modal_params = {}
    switch (action.type) {
      case CRUD.CREATE:
        params = {
          initValues: {...action.value},
          onSubmit: (values) => {
            onCreate(values, {})
          },
        }
        modal_params = {
          width: 600,
          title: (
            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
              {t('leave a feedback')}
            </div>
          ),
        }
        Content = CreateFeedbackForm
        break
      default:
        break
    }

    return (
      <Modal
        className="custom-modal"
        footer={null}
        onCancel={onCancel}
        open={action.type && action.type !== CRUD.DELETE}
        destroyOnHidden={true}
        {...modal_params}>
        <DelayRender lazy={true}>
          <Wrapper>
            {({isLoading, initialValues}) => {
              if (!!isLoading) {
                return <LoadingBlock/>
              }
              return (
                <Content
                  {...{
                    onCancel,
                    item: action.value,
                  }}
                  {...params}
                  initialValues={initialValues}
                />
              )
            }}
          </Wrapper>
        </DelayRender>
      </Modal>
    )
  }, [action])

  return {
    reportModal,
    handleReport,
    onCreate,
    onUpdate,
    onDelete,
    asyncCreating,
    asyncUpdating,
    asyncDeleting,
  }
}



